/* Pestañas de la descripción de producto - Salas García Ópticos
   Corta la descripción en cada título "Encabezado 3" (H3). El texto que va antes
   del primero es la pestaña "Descripción". Sin títulos no se crean pestañas. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var counter = 0;

  function txt(n) {
    return (n.textContent || '').replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function make(tag, cls) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    return e;
  }

  function hasContent(nodes) {
    return nodes.some(function (n) {
      if (n.nodeType === 3) return txt(n) !== '';
      if (n.nodeType !== 1) return false;
      if (n.tagName === 'IMG' || n.querySelector('img')) return true;
      return txt(n) !== '';
    });
  }

  function split(root) {
    var groups = [{ title: 'Descripción', nodes: [] }];
    Array.prototype.slice.call(root.childNodes).forEach(function (n) {
      if (n.nodeType === 1 && n.tagName === 'H3') {
        var t = txt(n);
        if (t) groups.push({ title: t, nodes: [] });
      } else if (!(n.nodeType === 1 && n.tagName === 'META')) {
        groups[groups.length - 1].nodes.push(n);
      }
    });
    return groups.filter(function (g) { return hasContent(g.nodes); });
  }

  /* Filas "Etiqueta: valor" solo si TODOS los párrafos tienen esa forma */
  function featureRows(nodes) {
    var items = [];
    var ok = nodes.every(function (n) {
      if (n.nodeType === 3) return txt(n) === '';
      if (n.nodeType !== 1) return true;
      if (txt(n) === '' && !n.querySelector('img')) return true;
      if (n.tagName !== 'P') return false;
      var s = n.querySelector('strong, b');
      if (!s) return false;
      var whole = txt(n), lead = txt(s);
      if (whole.indexOf(lead) !== 0) return false;
      var label = lead.replace(/:\s*$/, '');
      var value = whole.slice(lead.length).replace(/^\s*:?\s*/, '');
      if (!label || !value) return false;
      items.push([label, value]);
      return true;
    });
    if (!ok || items.length < 2) return null;
    var dl = make('dl', 'dt-rows');
    items.forEach(function (it) {
      var dt = make('dt'); dt.textContent = it[0];
      var dd = make('dd'); dd.textContent = it[1];
      dl.appendChild(dt); dl.appendChild(dd);
    });
    return dl;
  }

  function enhance(host) {
    if (host.getAttribute('data-dt')) return;
    if (host.closest && host.closest('quick-add-modal')) return;

    var root = host;
    if (host.children.length === 1 && host.firstElementChild.tagName === 'DIV') root = host.firstElementChild;

    var groups = split(root);
    if (groups.length < 2) { host.setAttribute('data-dt', 'plain'); return; }

    var uid = 'dt' + (++counter);
    host.setAttribute('data-dt', 'tabs');
    host.textContent = '';

    var scroller = make('div', 'dt-scroll');
    var bar = make('div', 'dt-tabs');
    bar.setAttribute('role', 'tablist');
    var ind = make('span', 'dt-ind');
    ind.setAttribute('aria-hidden', 'true');
    bar.appendChild(ind);
    var stack = make('div', 'dt-stack');

    var tabs = [], panels = [];
    groups.forEach(function (g, i) {
      var tab = make('button', 'dt-tab');
      tab.type = 'button';
      tab.id = uid + '-t' + i;
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-controls', uid + '-p' + i);
      tab.textContent = g.title;
      bar.appendChild(tab);
      tabs.push(tab);

      var panel = make('div', 'dt-panel');
      panel.id = uid + '-p' + i;
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('aria-labelledby', tab.id);
      var rows = /caracter/i.test(g.title) ? featureRows(g.nodes) : null;
      if (rows) panel.appendChild(rows);
      else g.nodes.forEach(function (n) { panel.appendChild(n); });
      stack.appendChild(panel);
      panels.push(panel);
    });

    scroller.appendChild(bar);
    host.appendChild(scroller);
    host.appendChild(stack);

    var cur = -1;

    function place() {
      var t = tabs[cur];
      if (!t) return;
      ind.style.width = t.offsetWidth + 'px';
      ind.style.transform = 'translateX(' + t.offsetLeft + 'px)';
    }
    function setHeight() {
      var p = panels[cur];
      if (p) stack.style.height = p.offsetHeight + 'px';
    }
    function select(i, byUser) {
      if (i === cur) return;
      cur = i;
      tabs.forEach(function (t, k) {
        t.setAttribute('aria-selected', k === i ? 'true' : 'false');
        t.tabIndex = k === i ? 0 : -1;
      });
      panels.forEach(function (p, k) {
        p.classList.toggle('dt-on', k === i);
        p.setAttribute('aria-hidden', k === i ? 'false' : 'true');
        if ('inert' in p) p.inert = k !== i;
      });
      place();
      if (byUser && scroller.scrollTo) {
        var t = tabs[i];
        scroller.scrollTo({
          left: t.offsetLeft - (scroller.clientWidth - t.offsetWidth) / 2,
          behavior: reduceMotion ? 'auto' : 'smooth'
        });
      }
      setHeight();
    }

    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(i, true); });
      t.addEventListener('keydown', function (e) {
        var n = -1;
        if (e.key === 'ArrowRight') n = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') n = 0;
        else if (e.key === 'End') n = tabs.length - 1;
        if (n >= 0) { e.preventDefault(); select(n, true); tabs[n].focus(); }
      });
    });

    host.classList.add('dt-init');
    select(0, false);
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () { host.classList.add('dt-ready'); });
    });

    stack.addEventListener('load', setHeight, true);
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(function () { setHeight(); place(); });
      panels.forEach(function (p) { ro.observe(p); });
      ro.observe(scroller);
    } else {
      window.addEventListener('resize', function () { setHeight(); place(); });
    }
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('.product__description'), enhance);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();